module.exports = __webpack_public_path__ + "img/ad_en1.d37f5c88.png";